'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodashMaxby = require('lodash.maxby');

var _lodashMaxby2 = _interopRequireDefault(_lodashMaxby);

var Popover = (function (_React$Component) {
    _inherits(Popover, _React$Component);

    function Popover(props) {
        _classCallCheck(this, Popover);

        _get(Object.getPrototypeOf(Popover.prototype), 'constructor', this).call(this, props);
        this.displayName = 'Popover';
        this.mainContainerRef = null;
        this.popoverContainerRef = null;
        this.arrowContainerRef = null;
        this.state = {
            show: false
        };
    }

    _createClass(Popover, [{
        key: 'updatePopoverStyle',
        value: function updatePopoverStyle(placement) {
            var mainContainer = this.mainContainerRef;
            var popoverContainer = this.popoverContainerRef;
            var arrowContainer = this.arrowContainerRef;

            var mainContainerWidth = mainContainer.offsetWidth;
            var mainContainerHeight = mainContainer.offsetHeight;

            var popoverContainerWidth = popoverContainer.offsetWidth;
            var popoverContainerHeight = popoverContainer.offsetHeight;
            var popoverContainerStyle = popoverContainer.style;

            var dir = this.props.dir;

            // Reseting popover styles
            popoverContainerStyle.marginLeft = null;
            popoverContainerStyle.left = null;
            popoverContainerStyle.marginRight = null;
            popoverContainerStyle.right = null;
            popoverContainerStyle.marginTop = null;
            popoverContainerStyle.marginBottom = null;
            popoverContainerStyle.top = null;
            popoverContainerStyle.bottom = null;

            switch (placement) {
                case 'top':
                    {
                        popoverContainerStyle.marginBottom = '5px';
                        popoverContainerStyle.bottom = mainContainerHeight + 'px';
                        popoverContainerStyle.marginLeft = dir === 'rtl' ? null : mainContainerWidth / 2 - popoverContainerWidth / 2 + 'px';
                        popoverContainerStyle.marginRight = dir === 'rtl' ? mainContainerWidth / 2 - popoverContainerWidth / 2 + 'px' : null;
                        arrowContainer.className = (0, _classnames2['default'])('Popover-arrow', 'Popover-top');
                        break;
                    }
                case 'right':
                    {
                        popoverContainerStyle.left = '100%';
                        popoverContainerStyle.marginLeft = '10px';
                        popoverContainerStyle.width = popoverContainerWidth + 'px';
                        popoverContainerStyle.marginTop = '-' + (mainContainerHeight / 2 + popoverContainerHeight / 2) + 'px';
                        arrowContainer.className = (0, _classnames2['default'])('Popover-arrow', dir === 'rtl' ? 'Popover-left' : 'Popover-right');
                        break;
                    }
                case 'left':
                    {
                        popoverContainerStyle.top = mainContainerHeight / 2 - popoverContainerHeight / 2 + 'px';
                        popoverContainerStyle.right = '100%';
                        popoverContainerStyle.marginRight = '8px';
                        popoverContainerStyle.width = popoverContainerWidth + 'px';
                        arrowContainer.className = (0, _classnames2['default'])('Popover-arrow', dir === 'rtl' ? 'Popover-right' : 'Popover-left');
                        break;
                    }
                case 'bottom':
                    {
                        popoverContainerStyle.marginTop = '5px';
                        popoverContainerStyle.marginLeft = dir === 'rtl' ? null : mainContainerWidth / 2 - popoverContainerWidth / 2 + 'px';
                        popoverContainerStyle.marginRight = dir === 'rtl' ? mainContainerWidth / 2 - popoverContainerWidth / 2 + 'px' : null;
                        arrowContainer.className = (0, _classnames2['default'])('Popover-arrow', 'Popover-bottom');
                        break;
                    }
            }
        }
    }, {
        key: 'getPlacement',
        value: function getPlacement() {
            var area = [];
            var mainRect = this.mainContainerRef.getBoundingClientRect();
            var viewportHeight = undefined,
                viewportWidth = undefined;

            if (window) {
                viewportWidth = window.innerWidth || 0;
                viewportHeight = window.innerHeight || 0;
            } else {
                viewportWidth = 768;
                viewportHeight = 1024;
            }

            area.push({
                placement: 'bottom',
                area: viewportWidth * (viewportHeight - mainRect.bottom) * 0.25
            });
            area.push({
                placement: 'right',
                area: viewportHeight * (viewportWidth - mainRect.right) * 0.25
            });
            area.push({
                placement: 'top',
                area: viewportWidth * mainRect.top * 0.25
            });
            area.push({
                placement: 'left',
                area: viewportHeight * mainRect.left * 0.25
            });

            return (0, _lodashMaxby2['default'])(area, 'area').placement;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var placement = this.props.placement === 'auto' ? this.getPlacement() : this.props.placement;
            //Change placement only when the placement is non-auto
            if (this.props.dir === 'rtl' && this.props.placement == 'left') {
                placement = 'right';
            } else if (this.props.dir === 'rtl' && this.props.placement == 'right') {
                placement = 'left';
            }
            this.updatePopoverStyle(placement);
        }
    }, {
        key: 'onClick',
        value: function onClick(event) {
            //If the popover is open and when the trigger is focus, do nothing
            if (this.state.show && this.props.trigger === 'focus') return false;

            //Toggle state - Need to revisit
            this.setState({ show: !this.state.show });
        }
    }, {
        key: 'onBlur',
        value: function onBlur(event) {
            var _this = this;

            setTimeout(function () {
                //Toggle state - Need to revisit
                _this.setState({ show: _this.state.show && !_this.state.show });
            }, 200);
        }
    }, {
        key: 'onMouseOver',
        value: function onMouseOver(event) {
            //Toggle state - Need to revisit
            this.setState({ show: !this.state.show });
        }
    }, {
        key: 'onMouseOut',
        value: function onMouseOut(event) {
            //Toggle state - Need to revisit
            this.setState({ show: !this.state.show });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var componentClass = (0, _classnames2['default'])('Popover', {
                'Popover-show': this.state.show
            });
            var eventHandlers = {
                onClick: this.props.trigger !== 'hover' ? this.onClick.bind(this) : null,
                onMouseOver: this.props.trigger === 'hover' ? this.onMouseOver.bind(this) : null,
                onMouseOut: this.props.trigger === 'hover' ? this.onMouseOut.bind(this) : null
            };

            return _react2['default'].createElement(
                'span',
                {
                    className: 'PopoverLabel',
                    tabIndex: '0',
                    onBlur: this.props.trigger === 'focus' ? this.onBlur.bind(this) : null
                },
                _react2['default'].createElement(
                    'div',
                    _extends({ ref: function (ref) {
                            _this2.mainContainerRef = ref;
                        } }, eventHandlers),
                    this.props.children
                ),
                _react2['default'].createElement(
                    'div',
                    { className: componentClass, id: this.props.id, ref: function (ref) {
                            _this2.popoverContainerRef = ref;
                        } },
                    this.props.title ? _react2['default'].createElement(
                        'div',
                        { className: 'Popover-title' },
                        ' ',
                        this.props.title
                    ) : false,
                    _react2['default'].createElement('div', { className: 'Popover-arrow', ref: function (ref) {
                            _this2.arrowContainerRef = ref;
                        } }),
                    _react2['default'].createElement(
                        'div',
                        { className: 'Popover-content' },
                        this.props.content
                    )
                )
            );
        }
    }]);

    return Popover;
})(_react2['default'].Component);

Popover.propTypes = {
    className: _propTypes2['default'].string,
    placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left', 'auto']),
    content: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].node]),
    trigger: _propTypes2['default'].oneOf(['hover', 'click', 'focus']),
    id: _propTypes2['default'].string,
    dir: _propTypes2['default'].oneOf(['ltr', 'rtl'])
};

Popover.defaultProps = {
    placement: 'top',
    trigger: 'hover',
    dir: 'ltr'
};

module.exports = Popover;


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/kepler/lib/components/Popover.js
// module id = 324
// module chunks = 0